import { cond, always, T, includes } from 'ramda';
import {
  ASC,
  DESC,
  SORT_BY_ASC_DATE,
  SORT_BY_DESC_DATE,
} from 'src/components/sorting';
import { USER_ONBOARD_ADMIN_ISO } from 'src/services/constants/accounts';
import { BREAKOUT_NAMESPACE_ID } from 'src/constants';
import { getNamespaceId } from "src/services/objects/namespaces";
import { isNotEmpty } from 'src/utilities/hasValue';

export const getApplicationSortOrder = (roles: string[], _nameSpaceId?: string) => {

  const nameSpaceId = getNamespaceId() || _nameSpaceId;

  return cond([
    [() => includes(USER_ONBOARD_ADMIN_ISO, roles), always(() => getDataDesc())],
    [() => includes(nameSpaceId, [BREAKOUT_NAMESPACE_ID]), always(() => getDataAsc())],
    [() => isNotEmpty(roles), always(() => getDataAsc())],
    [T, always(() => getDataDesc())],
  ])(roles)();
};

const getDataAsc = () => {
  return { order: ASC, orderBy: SORT_BY_ASC_DATE };
};

const getDataDesc = () => {
  return { order: DESC, orderBy: SORT_BY_DESC_DATE };
};
